import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import {
  TableBody,
  TableRow,
  TableCell,
  InputAdornment,
} from "@material-ui/core";
import axios from "axios";
import useTableScroll from "../../components/useTableScroll";
import { Mensaje, MensajeSiNo } from "../mensajes.js";

const CargarPucEfiscal = (props) => {
  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const efiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const statuspresup = JSON.parse(localStorage.getItem("statuspresup"));

  const btnCancela = useRef();
  const [values, setValues] = useState({});
  const [itemSelect, setItemSelect] = useState(-1);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "center" },
    { label: "AÑO", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idefiscal.includes(target.value) ||
              x.descriptor.toLowerCase().includes(target.value.toLowerCase()) ||
              x.anio.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarEjercicioFiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let orden = "idefiscal";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var clase = [];
          for (let i = 0; i < response.data.length; i++) {
            clase.push({
              idefiscal: response.data[i].idefiscal,
              descriptor: response.data[i].descriptor,
              anio: response.data[i].anio,
              observaciones: response.data[i].observaciones,
              statusorg: response.data[i].statusorg,
              statuspresup: response.data[i].statuspresup,
              statuspuc: response.data[i].statuspuc,
              statuscat: response.data[i].statuscat,
              idorganizacion: response.data[i].idorganizacion,
            });
          }
          setRecords(clase);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;

    if (sigue) {
      let msg = "";

      if (operacion === 2) {
        if (efiscal !== parseInt(values.idefiscal)) {
          msg = "Esta Seguro de Registrar estos Datos?.";
          setMensajesino({
            mostrar: true,
            titulo: "Confirmación.",
            texto: msg,
            icono: "confirmacion",
          });
        } else {
          msg = "Debe Seleccionar un Ejercicio Fiscal distinto al Actual";
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: msg,
            icono: "informacion",
          });
        }
      }
    }
  };

  const SeleccionarEfiscal = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "efiscal";
    let nomid = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${efiscal}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var idefiscal = response.data[0].idefiscal;
          var descriptor = response.data[0].descriptor;
          var anio = response.data[0].anio;
          var observaciones = response.data[0].observaciones;
          var statusorg = response.data[0].statusorg;
          var statuspresup = response.data[0].statuspresup;
          var statuspuc = response.data[0].statuspuc;
          var statuscat = response.data[0].statuscat;
          var idorganizacion = response.data[0].idorganizacion;

          localStorage.setItem("idefiscal", idefiscal);
          localStorage.setItem("efiscaldes", descriptor);
          localStorage.setItem("efiscalanio", anio);
          localStorage.setItem("efiseleccionado", true);
          localStorage.setItem("statuspresup", statuspresup);
          localStorage.setItem("statuspuc", statuspuc);
          localStorage.setItem("statuscat", statuscat);
          localStorage.setItem("statusorg", statusorg);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/cargarpucefiscal`;
    let body;
    setActivate(true);

    body = {
      efiscalA: values.idefiscal,
      efiscalB: efiscal,
      statuspresu: statuspresup,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Registro Creado Correctamente",
            icono: "exito",
          });
          SeleccionarEfiscal();
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setItemSelect("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancela();
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    Actualizar();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancela();
    blanquear();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setValues({
      idefiscal: recordsAfterPagingAndSorting()[index].idefiscal,
      descriptor: recordsAfterPagingAndSorting()[index].descriptor,
      anio: recordsAfterPagingAndSorting()[index].anio,
      observaciones: recordsAfterPagingAndSorting()[index].observaciones,
      statusorg: recordsAfterPagingAndSorting()[index].statusorg,
      statuspresup: recordsAfterPagingAndSorting()[index].statuspresup,
      statuspuc: recordsAfterPagingAndSorting()[index].statuspuc,
      statuscat: recordsAfterPagingAndSorting()[index].statuscat,
      idorganizacion: recordsAfterPagingAndSorting()[index].idorganizacion,
    });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarEjercicioFiscal();
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Cargar Clasificador Presupuestario desde Ejercicio Fiscal.</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() => {
            mensaje.titulo === "Exito."
              ? cerrarModal()
              : setMensaje({
                  mostrar: false,
                  titulo: "",
                  texto: "",
                  icono: "",
                });
          }}
        />
        <MensajeSiNo
          mensaje={mensajesino}
          onHideNo={() =>
            setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
          onHideSi={handleCloseSi}
        />
        <Dimmer active={activate} />
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-2 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control"
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={item.idefiscal}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.idefiscal}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.descriptor}
                    </TableCell>
                    <TableCell className="py-2 text-center">
                      {item.anio}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={itemSelect === -1 ? true : false}
          style={{ margin: "5px" }}
          onClick={onChangeValidar}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CargarPucEfiscal;



// WEBPACK FOOTER //
// ./src/components/presupuesto/modalCargarPucdesdeEfiscal.js